import { render, staticRenderFns } from "./StudentKrokResults.vue?vue&type=template&id=d1098e96"
import script from "./StudentKrokResults.vue?vue&type=script&lang=js"
export * from "./StudentKrokResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports